import { createFileRoute } from '@tanstack/react-router';
import { getPageWithContent } from '@/services/docs';
import DocsGroupPage, { DocsGroupPageLoading } from '@/components/Docs/DocsGroupPage';

export const Route = createFileRoute('/developers/v1/$section/$slug')({
  loader: async ({ params }) =>
    getPageWithContent(params.section, params.slug, 'developers', 'v1'),
  pendingComponent: DocsGroupPageLoading,
  component: DevelopersV1Page,
});

function DevelopersV1Page() {
  const page = Route.useLoaderData();
  return <DocsGroupPage page={page} />;
}
